import { priceCommaReplacer } from '../../core/utils/methods';
import { InputNumberFormatterType } from '../types';

export const PERCENT_PREFIX = (value: InputNumberFormatterType): string =>
  `${value} %`;

export const DOLLAR_PREFIX = (value: InputNumberFormatterType): string =>
  priceCommaReplacer(`$ ${value}`);
